import { Box, AppBar } from '@material-ui/core';
import styled from 'styled-components';

export const CustomAppBar = styled(AppBar)`
  justify-content: center;
  align-items: center;
  height: 64px;
`;

export const ImageContainer = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

export const MultipleImageContainer = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 60%;
  box-sizing: border-box;
  padding: 0 40px;

  @media (max-width: 768px) {
    width: 100%;
  }
`;
